module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_gosquared-4880cb861ffe0a932cb864f0f43af178.png";